import { Component, Input, OnInit } from '@angular/core';
// import * as $ from 'jquery';
import $ from 'jquery';

import { SwiperComponent } from "swiper/angular";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";
import { DashboardService } from 'src/app/service/dashboard.service';
SwiperCore.use([Autoplay, Pagination, Navigation]);


@Component({
  selector: 'app-text-display',
  templateUrl: './text-display.component.html',
  styleUrls: ['./text-display.component.css']
})
export class TextDisplayComponent implements OnInit {
  images = [944, 1011, 984].map((n) => `https://picsum.photos/id/${n}/900/500`);
  annouceList : any;
  constructor(private dashboardService:DashboardService) { }

  @Input()
  deviceXs!: boolean;

  @Input()
  deviceSm!: boolean;

  @Input()
  deviceMd! : boolean;

  @Input()
  deviceLg! : boolean;

  @Input()
  deviceXl! : boolean;

  ngOnInit(){
    this.dashboardService.loadAnnoucements().subscribe(
      (res: any) => {
        this.annouceList = res['announcement'];
        this.annouceList[2] = "With all of its features, Agora creates clarity and efficiency in our meetings which contribute to the overall health and success of our organization."
      },
      err => {
        //
      })
  }

}
